var React = require('react');

function QuoteChat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M78.731 44.6076H52.5787V31H16V58.0442H29.8426L38.868 62.6337V58.0442H43.4924V70.4806C43.4924 71.1743 44.0609 71.7373 44.7614 71.7373H52.5178V74.7433C52.5178 75.1806 52.7462 75.5878 53.1269 75.814C53.3299 75.9347 53.5584 76 53.7868 76C53.9848 76 54.1827 75.9548 54.3655 75.8592L62.4721 71.7373H78.731C79.4315 71.7373 80 71.1743 80 70.4806V45.8643C80 45.1706 79.4315 44.6076 78.731 44.6076ZM77.4619 69.2239H62.1675C61.9645 69.2239 61.7665 69.2691 61.5888 69.3646L55.0558 72.6873V70.4856C55.0558 69.7919 54.4873 69.2289 53.7868 69.2289H46.0305V47.126H77.4619V69.2289V69.2239Z","fill":"#0000FF"}));
}

QuoteChat.defaultProps = {"width":"96","height":"100","viewBox":"0 0 96 100","fill":"none"};

module.exports = QuoteChat;

QuoteChat.default = QuoteChat;
